/**
 * Canonical LOTSOG Learning terminology for all new/modified code.
 *
 * Rules:
 * 1) Never use "class" in new UI strings to mean a period of instruction.
 * 2) "Learning Path" is self-serve only. "Course" is teacher-assigned.
 * 3) Do not rename Firestore collection IDs in this pass.
 */
export const TERM_COURSE = 'Course';
export const TERM_COURSES = 'Courses';
export const TERM_SECTION = 'Section';
export const TERM_SECTIONS = 'Sections';
export const TERM_LESSON = 'Lesson';
export const TERM_TRACK = 'Track';
export const TERM_LEARNING_PATH = 'Learning Path';
export const TERM_LEARNING_PATHS = 'Learning Paths';

export const LOTSOG_LEARNING_UI = {
  section: {
    singular: TERM_SECTION,
    plural: TERM_SECTIONS,
    yourSections: 'Your Sections',
    newSection: 'New Section',
    chooseSection: 'Choose a section',
    assignToSection: 'Assign to a section',
    sectionName: 'Section name',
    manageSectionsAndCourses: 'Manage sections and courses',
  },
  course: {
    singular: TERM_COURSE,
    plural: TERM_COURSES,
    myCourses: 'My Courses',
    openCourse: 'Open Course',
  },
  lesson: {
    singular: TERM_LESSON,
    startLessonOne: 'Start Lesson 1 ->',
    writingLessonOne: 'Writing Lesson 1...',
    lessonOneReadyPrefix: 'Lesson 1 is ready.',
    progressLabel: (current, total) => `Lesson ${current} of ${total}`,
  },
  learningPath: {
    singular: TERM_LEARNING_PATH,
    plural: TERM_LEARNING_PATHS,
    exploreThisTopic: 'Explore this topic',
    planning: 'Planning your Learning Path…',
    building: 'Building your Learning Path…',
    myLearningPaths: 'My Learning Paths',
    itemPrefix: 'Learning Path:',
    startPath: 'Start Learning Path',
    createPath: 'Create Learning Path',
    openOrCreatePath: 'Open or create Learning Path',
  },
};

/**
 * Internal storage names intentionally remain unchanged in this pass.
 */
export const LOTSOG_LEARNING_INTERNAL = {
  collections: {
    teacherCourses: 'lotsogTeacherCurricula',
    sections: 'lotsogClasses',
    tracks: 'lotsogLearningTracks',
    trackJobs: 'lotsogLearningTrackJobs',
  },
  fields: {
    sectionId: 'classId',
    courseId: 'curriculumId',
    trackId: 'trackId',
    lessonDay: 'day',
  },
};

export const LOTSOG_LEARNING_RULES = Object.freeze([
  'Never use "class" in new UI strings to mean a period of instruction.',
  '"Learning Path" is self-serve only. "Course" is teacher-assigned.',
  'Do not rename Firestore collection ID strings in this pass.',
]);
